import CommonDashboard from "../pages/CommondashBoard";
import Staff from "../pages/Staff";
import State from "../pages/State";
import City from "../pages/City";
import CityDistance from "../pages/CityDistance";
import AirportCity from "../pages/AirportCity";
import Role from "../pages/Role";
import Permission from "../pages/Permission";
import RegistrationType from "../pages/RegistrationType";
import Addons from "../pages/Addons";
import Vehicle from "../pages/Vehicle";
import VehicleRequestQueue from "../pages/VehicleRequestQueue";
import DriverRequestQueue from "../pages/driverRequestQueue";
import VehicleCategory from "../pages/VehicleCategory";
import VehicleType from "../pages/VehicleType";
import VehicleModel from "../pages/VehicleModel";
import Vendor from "../pages/Vendor";
import VendorRequest from "../pages/VendorRequest";
import Driver from "../pages/Driver";
import VehicleAllot from "../pages/VehicleAllot";
import VendorAllotment from "../pages/VendorAllotment";
import Page404 from "../pages/404";
import ComingSoon from "../pages/ComingSoon";
import EditProfile from "../pages/EditProfile";
import Agents from "../pages/Agents";
import Bookings from "../pages/Bookings";
import AirportPickupBasicRate from "../pages/AirportPickupBasicRate";
import AirportPickupPeriodicHikeDay from "../pages/AirportPickupPeriodicHikeDay";
import AirportPickupPeriodicHikeTime from "../pages/AirportPickupPeriodicHikeTime";
import FixedItinerary from "../pages/FixedItinerary";
import HourRentalPeriodicHikeDay from "../pages/HourRentalPeriodicHikeDay";
import DayRentalPeriodicHikeDay from "../pages/DayRentalPeriodicHikeDay";
import FixedItineraryPeriodicHike from "../pages/FixedItineraryPeriodicHike";
import TopSellingPackage from "../pages/TopSellingPackage";
import FixedItineraryCancellation from "../pages/CancellationPolicyFixedItinerary";
import AirportPickupCancellation from "../pages/CancellationPolicyAirportPickup";
import DayRentalCancellation from "../pages/CancellationPolicyDayRental";
import HourRentalCancellation from "../pages/CancellationPolicyHourRental";
import DayRentalBasicRate from "../pages/DayRentalBasicRate";
import HourRentalBasicRate from "../pages/HourRentalBasicRate";
import HourRentalPeriodicHikeTime from "../pages/HourRentalPeriodicHikeTime";
import SeoManageCity from "../pages/SeoManageCity";
import SeoPage from "../pages/SeoPage";
import Advertisement from "../pages/Advertisement";
import PartialPayment from "../pages/PartialPayment";
import Permit from "../pages/Permit";
import Contact from "../pages/Contact";
import Career from "../pages/Career";
import SoldOut from "../pages/SoldOut";
import Subusers from "../pages/Subusers";
import Subscribe from "../pages/Subscribe";
import Jobtitle from "../pages/Jobtitle";
import Tripadvance from "../pages/Tripadvance";
import PurchaseBill from "../pages/PurchaseBill";
import BillPaymentReport from "../pages/BillPaymentReport";
import VendorLedger from "../pages/VendorLedger";
import ClientFeedback from "../pages/ClientFeedback";
import PaymentDetails from "../pages/PaymentDetails";
import RazorpayDetails from "../pages/RazorpayDetails";
import RazorpayOrderDetails from "../pages/RazorpayOrderDetails";
import CancellationPolicy from "../pages/CancellationPolicy";
import LanguageDriver from "../pages/LanguageDriver";
import Menu from "../pages/Menu";
import BillApproval from "../pages/BillApproval";
import BillDetailsPayment from "../pages/BillDetailsPayment";
import TripadvanceApproval from "../pages/TripadvanceApproval";
import Notification from "../pages/Notification";
import TripadvancePayment from "../pages/TripadvancePayment";
import ApkUpload from "pages/ApkUpload";
import ApkWaiter from "pages/ApkWaiter";
import TripadvanceApprovalTrans from "../pages/TripadvanceApprovalTrans";
import Sales from "pages/Sales";
import RevenueReport from "pages/RevenueReport";
import Parking from "../pages/Parking";
import WhatsApp from "pages/WhatsApp";
import CityLink from "pages/CityLink";

import CityVendorRequest from "pages/CityVendorRequest";
import Toll from "pages/Toll";
import OnTourFeedback from "pages/OnTourFeedback";
import SeoVirtual from "pages/SeoVirtual";
import FencingCity from "pages/FencingCity";
import CityAutocompletion from "pages/CityAutocompletion";
import OnewayPickupBasicRate from "../pages/OnewaypickupBasicRate";
import OnewayPickupPeriodicHikeDay from "../pages/OnewayPeriodicHikeDay";
import OnewayPickupPeriodicHikeTime from "../pages/OnewayPickupPeriodicHikeTime";
import CancellationPolicyOnewayPickup from "../pages/CancellationPolicyOnewayPickway";
import ChannelPartnerList from "../pages/ChannelPartnerList";
import Gatewaymethod from "pages/PaymentGatewayMethod";
import B2BNews from "pages/news";
import MinDuration from "pages/MinDuration";
import Franchise from "pages/Franchise";
import FranchiseAllotment from "pages/FranchiseAllotment";
import CommisionPayment from "pages/CommisionPayment";
import CommissionPayment from "pages/CommisionPayment";
import OverallNotification from "pages/OverallNotification";
import BasicMargin from "pages/BasicMargin";
import OverrideMargin from "pages/OverrideMargin";
import VendorRatesPage from "../pages/VendorRatesPage";
import { components } from "react-select";
import Email from "pages/Email";
import ItineraryBasicMargin from "pages/ItineraryBasicMargin";
import ItineraryPeriodicMargin from "pages/ItineraryPeriodicMargin";
import TrustedCompanies from "pages/TrustedCompanies";

// import

// const Chat = lazy(() => import('../pages/Chat'));

/*
//  * ⚠ These are internal routes!
//  * They will be rendered inside the app, using the default `containers/Layout`.
//  * If you want to add a route to, let's say, a landing page, you should add
//  * it to the `App`'s router, exactly like `Login`, `CreateAccount` and other pages
//  * are routed.
//  *
//  * If you're looking for the links rendered in the SidebarContent, go to
//  * `routes/sidebar.js`
 */

const routes = [
  {
    path: "/dashboard",
    component: CommonDashboard,
  },
  {
    path: "/menu",
    component: Menu,
  },
  {
    path: "/employee",
    component: Staff,
  },
  {
    path: "/roles",
    component: Role,
  },
  {
    path: "/states",
    component: State,
  },
  {
    path: "/city",
    component: City,
  },
  {
    path: "/city-distance",
    component: CityDistance,
  },
  {
    path: "/airport-city",
    component: AirportCity,
  },
  {
    path: "/permissions",
    component: Permission,
  },

  {
    path: "/vehicle-category",
    component: VehicleType,
  },

  {
    path: "/vehicle-type",
    component: VehicleModel,
  },

  {
    path: "/vehicle-model",
    component: VehicleCategory,
  },

  {
    path: "/registration-type",
    component: RegistrationType,
  },
  {
    path: "/addons",
    component: Addons,
  },
  {
    path: "/vendor",
    component: Vendor,
  },
  {
    path: "/vendor-enquiry",
    component: VendorRequest,
  },
  {
    path: "/purchasebill",
    component: PurchaseBill,
  },
  {
    path: "/vehicle-allotment",
    component: VehicleAllot,
  },
  {
    path: "/driver",
    component: Driver,
  },
  {
    path: "/vendorallotment",
    component: VendorAllotment,
  },
  {
    path: "/vehicle",
    component: Vehicle,
  },
  {
    path: "/vehicleRequestQueue",
    component: VehicleRequestQueue,
  },
  {
    path: "/driverRequestQueue",
    component: DriverRequestQueue,
  },

  {
    path: "/agentslist",
    component: Agents,
  },
  {
    path: "/bookings",
    component: Bookings,
  },
  {
    path: "/driverlanguage",
    component: LanguageDriver,
  },
  {
    path: "/airportPickup-basic-rate",
    component: AirportPickupBasicRate,
  },
  {
    path: "/basic-rate-day",
    component: DayRentalBasicRate,
  },
  {
    path: "/basic-rate-hour",
    component: HourRentalBasicRate,
  },
  {
    path: "/periodic-hike-hour-time",
    component: HourRentalPeriodicHikeTime,
  },
  {
    path: "/periodic-hike-airport-day",
    component: AirportPickupPeriodicHikeDay,
  },
  {
    path: "/periodic-hike-airport-time",
    component: AirportPickupPeriodicHikeTime,
  },
  {
    path: "/basic-rate-fixed",
    component: FixedItinerary,
  },

  {
    path: "/periodic-hike-fixed",
    component: FixedItineraryPeriodicHike,
  },
  {
    path: "/holiday-package",
    component: TopSellingPackage,
  },
  {
    path: "/periodic-hike-hour-day",
    component: HourRentalPeriodicHikeDay,
  },
  {
    path: "/periodic-hike-day",
    component: DayRentalPeriodicHikeDay,
  },
  {
    path: "/cancellation-policy-fixed",
    component: FixedItineraryCancellation,
  },
  {
    path: "/cancellation-policy-airport",
    component: AirportPickupCancellation,
  },
  {
    path: "/cancellation-policy-day",
    component: DayRentalCancellation,
  },
  {
    path: "/cancellation-policy-hour",
    component: HourRentalCancellation,
  },
  {
    path: "/404",
    component: Page404,
  },
  {
    path: "/coming-soon",
    component: ComingSoon,
  },
  {
    path: "/edit-profile",
    component: EditProfile,
  },
  {
    path: "/manage-city",
    component: SeoManageCity,
  },
  {
    path: "/seo-page",
    component: SeoPage,
  },
  {
    path: "/advertisement",
    component: Advertisement,
  },
  {
    path: "/partialpayment",
    component: PartialPayment,
  },
  {
    path: "/permit",
    component: Permit,
  },
  {
    path: "/contact",
    component: Contact,
  },
  {
    path: "/career",
    component: Career,
  },
  {
    path: "/subusers",
    component: Subusers,
  },
  {
    path: "/subscribe",
    component: Subscribe,
  },

  {
    path: "/jobtitle",
    component: Jobtitle,
  },
  {
    path: "/tripadvance",
    component: Tripadvance,
  },
  {
    path: "/billpaymentreport",
    component: BillPaymentReport,
  },
  {
    path: "/vendorledger",
    component: VendorLedger,
  },
  {
    path: "/cancellationPolicy",
    component: CancellationPolicy,
  },
  {
    path: "/clientfeedback",
    component: ClientFeedback,
  },
  {
    path: "/paymentdetails",
    component: PaymentDetails,
  },
  {
    path: "/razorpaydetails",
    component: RazorpayDetails,
  },
  {
    path: "/razorpayorderdetails",
    component: RazorpayOrderDetails,
  },
  {
    path: "/bill-details-approval",
    component: BillApproval,
  },
  {
    path: "/bill-details-payment",
    component: BillDetailsPayment,
  },
  {
    path: "/trip-advance-approval",
    component: TripadvanceApproval,
  },
  {
    path: "/trip-advance-payment",
    component: TripadvancePayment,
  },
  {
    path: "/notification",
    component: Notification,
  },
  {
    path: "/soldOut",
    component: SoldOut,
  },
  {
    path: "/apk-upload",
    component: ApkUpload,
  },
  {
    path: "/apk-waiter",
    component: ApkWaiter,
  },
  {
    path: "/tripadvance-approval",
    component: TripadvanceApprovalTrans,
  },
  {
    path: "/sales",
    component: Sales,
  },
  {
    path: "/revenue-report",
    component: RevenueReport,
  },
  {
    path: "/parking",
    component: Parking,
  },
  {
    path: "/whatsapp",
    component: WhatsApp,
  },
  {
    path: "/citylink",
    component: CityLink,
  },

  {
    path: "/city-vendor-request",
    component: CityVendorRequest,
  },
  {
    path: "/toll",
    component: Toll,
  },
  {
    path: "/ontour-feedback",
    component: OnTourFeedback,
  },
  {
    path: "/seo-virtual",
    component: SeoVirtual,
  },
  {
    path: "/fencing-city",
    component: FencingCity,
  },
  {
    path: "/City-Autocompletion",
    component: CityAutocompletion,
  },
  {
    path: "/oneway-pickup-basicrate",
    component: OnewayPickupBasicRate,
  },
  {
    path: "/oneway-periodic-hike-day",
    component: OnewayPickupPeriodicHikeDay,
  },
  {
    path: "/oneway-periodic-hike-time",
    component: OnewayPickupPeriodicHikeTime,
  },
  {
    path: "/oneway-cancelation-policy",
    component: CancellationPolicyOnewayPickup,
  },
  {
    path: "/channel-partner-form",
    component: ChannelPartnerList,
  },
  {
    path: "/gateway-payment-method",
    component: Gatewaymethod,
  },
  {
    path: "/b2b-news",
    component: B2BNews,
  },
  {
    path: "/min-duration",
    component: MinDuration,
  },
  {
    path: "/franchise",
    component: Franchise,
  },
  {
    path: "/franchise-allotment",
    component: FranchiseAllotment,
  },
  {
    path: "/commision-payment",
    component: CommissionPayment,
  },

  {
    path: "/notifications",
    component: OverallNotification,
  },
  {
		path:"/vendor-rates",
		component:VendorRatesPage
	},
  {
    path: "/basic-margin",
    component: BasicMargin
  },
  {
    path: "/periodic-margin",
    component: OverrideMargin
  },
  {
    path:"/email",
    component:Email

  },

  {
    path: "/itinerary-basic-margin",
    component: ItineraryBasicMargin
  },
  {
    path: "/itinerary-periodic-margin",
    component: ItineraryPeriodicMargin
  },
    {
    path: "/trusted-companies",
    component: TrustedCompanies
  },
  
];

export default routes;

